// Services
import httpService from "@/services/http";
// Types
import { USER_ACTIONS } from "./types";
import { UPDATE_MODEL, LOADING, LOADED } from "@/store/mutations-types";
// Model
import getModel from "./model";

export default {
  state: {
    loading: false,
    model: getModel(),
    params: {},
    list: [],
  },
  mutations: {
    [USER_ACTIONS.RESET_USER](state) {
      state.model = getModel();
    },
  },
  actions: {
    async [USER_ACTIONS.AUTH_USER]({ dispatch, commit }, id) {
      commit(LOADING, USER_ACTIONS.MODULE_USER);

      try {
        await httpService.authUser(id);
        await dispatch(USER_ACTIONS.FETCH_INFO_USER);
      } finally {
        commit(LOADED, USER_ACTIONS.MODULE_USER);
      }
    },
    async [USER_ACTIONS.FETCH_INFO_USER]({ commit }) {
      commit(LOADING, USER_ACTIONS.MODULE_USER);

      try {
        const model = await httpService.getJudgeInfo();
        commit(UPDATE_MODEL, {
          name: USER_ACTIONS.MODULE_USER,
          model,
        });
      } finally {
        commit(LOADED, USER_ACTIONS.MODULE_USER);
      }
    },
  },
};
